module.exports = __webpack_public_path__ + "static/media/grd_logo_white.ff17a57a.png";